// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__12M8J","additionalInfo":"AgreementModal_additionalInfo__JPJ6-"};